import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { baseParametersTC } from "../../utils/tableau/TableauEmbed";
import { useDashboardFiltersContext } from "../../utils/context/dashboardFilters/dashboardFiltersContextStateConfig";
import CustomViewsHandler from "../CustomViewsHandler/CustomViewsHandler";
import { applyExtraFilters, handleFilterChange, handleParameterChange } from "../../utils/actions/actions";
import gifLoading from "../../assets/gifs/Lightcast_LoadingGif_Sailor_Red.gif";

const loadingMessages = [
    "Applying saved filters...",
    "Updating dashboard parameters...",
    "This may take a few seconds...",
];

const DashboardCloud = ({
        link,
        locale,
        width = 1000,
        height = 800,
        hideToolbar = false,
        customParameters = [...baseParametersTC, { name: ":language", value: locale }],
        sidebar,
        setHideBar,
        stickyFiltersEnabled = false,
        solutionConfigurationEnabled = false,
        userId,
        scope
    }) => {

    
    
    const { dashboardFilters, setDashboardFilters } = useDashboardFiltersContext();
    const [ DashboardContentLoading, setDashboardContentLoading ] = useState(false);
    const [ loadingMessageIndex, setLoadingMessageIndex ] = useState(0);
    const dashboardLoaded = useRef(false);


    useEffect(() => {
        if(!DashboardContentLoading){
            setLoadingMessageIndex(0);
            return;
        }

        const loadingMessageInterval = setInterval(() => {
            setLoadingMessageIndex((currentIndex) =>
                (currentIndex + 1) % loadingMessages.length
            );
        }, 4000);

        return () => clearInterval(loadingMessageInterval);
    }, [DashboardContentLoading]);


    useEffect(() => {
        if(window.innerWidth > 767){
            if(sidebar === "HIDDEN") {
                setHideBar(sidebar);
            }else if(sidebar === "ALWAYS OPEN") {
                setHideBar(sidebar);
            }else if(sidebar === "CLOSED") {
                setHideBar(true);
            }else{
                setHideBar(null);
            }
        }
    }, [sidebar, setHideBar]);



    const initializeViz = (token, mantainFilters, customView =  null) => {
        let viz = document.getElementById("viz");
        viz.innerHTML = "";
        let tableauViz = document.getElementById("tableauViz");

        tableauViz = document.createElement("tableau-viz");
        tableauViz.setAttribute("id", "tableauViz");
        hideToolbar && tableauViz.setAttribute("toolbar", "hidden");
        hideToolbar && tableauViz.setAttribute("hide-tabs", "");
        hideToolbar && tableauViz.setAttribute("hide-edit-button", "");
        hideToolbar && tableauViz.setAttribute("hide-edit-in-desktop-button", "");
        tableauViz.setAttribute("token", token);

        customParameters.forEach((param) => {
            let customParam = document.createElement("custom-parameter");
            customParam.setAttribute("name", param.name);
            customParam.setAttribute("value", param.value);
            tableauViz.appendChild(customParam);
        });

        tableauViz.src = link;
        tableauViz.language = locale;

        if(stickyFiltersEnabled){
            tableauViz.addEventListener("parameterchanged", (event) =>
                handleParameterChange(event, scope, setDashboardFilters)
            );

            tableauViz.addEventListener("filterchanged", (event) =>  
                handleFilterChange(event, scope, setDashboardFilters)
            );

            if(customView){
                setDashboardContentLoading(true);
                tableauViz.addEventListener("firstinteractive", async () => {
                    await applyExtraFilters(customView, scope, setDashboardFilters, false, setDashboardContentLoading);
                });
            }else if((dashboardFilters[scope]?.filters.length > 0 || dashboardFilters[scope]?.parameters.length > 0) && mantainFilters){
                setDashboardContentLoading(true);
                tableauViz.addEventListener("firstinteractive", async () => {
                    await applyExtraFilters(dashboardFilters[scope], scope, setDashboardFilters, false, setDashboardContentLoading);
                });
            }
        }

        viz.appendChild(tableauViz);

        dashboardLoaded.current = true;
    };

    const loadDashboard = (mantainFilters = true, customView) => {
        fetch(
            "https://svi43pyq2a26gzdihakztev72m0isxob.lambda-url.eu-west-1.on.aws/?app=gsw",
            {
            method: "GET",
            }
        )
        .then((response) => response.text())
        .then((token) => {
            initializeViz(token, mantainFilters, customView);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    useEffect(() => {
        dashboardLoaded.current = false;
    }, [link]);
    
    useEffect(() => {
        if(!dashboardLoaded.current){
            loadDashboard();
        }
    });


    // const setParametro = async () => {

    //     try {
    //         const tableauViz = document.getElementById("tableauViz");

    //         if (!tableauViz || !tableauViz.workbook) {
    //             console.warn("Viz non pronta");
    //             return;
    //         }

    //         await tableauViz.workbook.changeParameterValueAsync(
    //             "Parametro periodo",
    //             "ULTIMI 3 MESI"
    //         );
    //         console.log("Parametro aggiornato!");

    //         return;
    //     } catch (err) {
    //         console.error("Errore set parametri:", err);
    //     }
    // };

    // const readDashboardFilters = async () => {
    //     try {
    //         const tableauViz = document.getElementById("tableauViz");
        
    //         if (!tableauViz?.workbook) return;

    //         const workbook = tableauViz.workbook;
    //         const activeSheet = workbook.activeSheet;


    //         if (activeSheet.sheetType === "dashboard") {
    //             const worksheets = activeSheet.worksheets;

    //             const all = (
    //                 await Promise.all(
    //                     worksheets.map(async (ws) => {
    //                     const wsFilters = await ws.getFiltersAsync();

    //                     const filteredFilters = wsFilters.map((f) => (
    //                         {
    //                             name: f.fieldName,
    //                             type: f.filterType,
    //                             appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
    //                         }
    //                     )).filter((f) => f.appliedValues.length > 0);

    //                     if (filteredFilters.length === 0) {
    //                         return null;
    //                     }

    //                     return {
    //                         worksheet: ws.name,
    //                         filters: filteredFilters,
    //                     };
    //                 }))
    //             ).filter(Boolean);

    //             console.log("[Tableau] Dashboard filters:", all);

    //             return;
    //         }

    //         const wsFilters = await activeSheet.getFiltersAsync();
    //         const single = [
    //             {
    //                 worksheet: activeSheet.name,
    //                 filters: wsFilters.map((f) => (
    //                     {
    //                         name: f.fieldName,
    //                         type: f.filterType,
    //                         appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
    //                     }
    //                 )).filter((f) => f.appliedValues.length > 0)
    //             },
    //         ];

    //         console.log("[Tableau] Worksheet filters:", single);
    //     } catch (error) {
    //         console.error("[Tableau] Error reading filters:", error);
    //     }
    // };

    return (
        <Row className="justify-content-md-center" id="view">
            <Col xs={12} className="mb-4 d-none d-sm-block">
                {
                    solutionConfigurationEnabled && scope &&
                    <CustomViewsHandler 
                        currentFilters={dashboardFilters[scope] ?? []} 
                        setFilters={setDashboardFilters}
                        loadingApplyFilters={setDashboardContentLoading}
                        reloadView={loadDashboard}
                        userId={userId} 
                        scope={scope} 
                    />
                }
                <section
                    className="tableau-cloud-stage"
                    style={{
                        minWidth: `${width}px`,
                        width: `${width}px`,
                        minHeight: `${hideToolbar ? height : height + 27}px`,
                        height: `${hideToolbar ? height : height + 27}px`,
                    }}
                >
                    <div
                        className="tableauCloud"
                        id="viz"
                    ></div>
                    {
                        DashboardContentLoading &&
                        <div
                            className="dashboard-content-loading"
                            role="status"
                            aria-label="Loading dashboard content"
                        >
                            <img
                                className="loading-screen__gif"
                                src={gifLoading}
                                alt=""
                            />
                            <p className="dashboard-content-loading__message pt-4">
                                {loadingMessages[loadingMessageIndex]}
                            </p>
                        </div>
                    }
                </section>
                <div className="footer-gradient"></div>
            </Col>
        </Row>
    );
};


export default DashboardCloud;
